const React = require('react');
const {
  Link,
} = require('../../../../router');
const {getUserMainPage} = require("../../../../emitters/account");

module.exports = (props) => {
  const link = getUserMainPage();

  return (
    <div className="h layoutRow fvaC fhaC">
      <div className="f20 fw3 mhA wmax600 ph15 tc lh">
        <div className="f100 fw7">403</div>
        <div className="mt20 f26">Access denied</div>
        <div className="mt10 f18">
          Sorry, you don&prime;t have permission to access this page.
          Please communicate with admin.
        </div>
        <div className="mt20">
          <Link
            className="c5B47FF olN dn f16 o70:h"
            href={link}
          >
            Go back to the main page
          </Link>
        </div>
      </div>
    </div>
  );
};
